import {
  isAfter,
  isBefore,
  isSameDay as isSameDayFns,
  isWithinInterval,
  startOfDay,
} from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

import { DateRange } from '@/models/helpers'

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return isSameDayFns(date1, date2)
}

export const isDateSelected = (date: Date, value?: Date | DateRange | null): boolean => {
  if (!value) return false

  // Note: Single date selection
  if (value instanceof Date) {
    return isSameDay(value, date)
  }

  // Note: Range selection - check if date matches either start or end
  if (Array.isArray(value) && value.length === 2) {
    const [start, end] = value
    if (start && isSameDay(date, start)) return true
    if (end && isSameDay(date, end)) return true
  }

  return false
}

export const isDateInRange = (date: Date, value?: Date | DateRange | null): boolean => {
  if (!value) return false

  // Note: Single date - no range
  if (value instanceof Date) {
    return false
  }

  // Note: Range selection - check if date is between start and end
  if (Array.isArray(value) && value.length === 2) {
    const [start, end] = value
    if (!start || !end) return false

    try {
      return isWithinInterval(date, { end, start })
    } catch {
      return false
    }
  }

  return false
}

export const isDateDisabled = (date: Date, minDate?: Date, maxDate?: Date): boolean => {
  if (minDate && isBefore(date, minDate)) return true
  if (maxDate && isAfter(date, maxDate)) return true
  return false
}

export const getInitialMonth = (value?: Date | DateRange | null): Date => {
  if (!value) return new Date()
  if (value instanceof Date) return new Date(value)
  if (Array.isArray(value) && value.length === 2 && value[0] instanceof Date)
    return new Date(value[0])
  return new Date()
}

export const getToday = (timezone?: string): Date =>
  startOfDay(timezone ? toZonedTime(new Date(), timezone) : new Date())
